import { motion } from "framer-motion";

const stats = [
  { value: "50+", label: "Clients Served" },
  { value: "20+ Yrs", label: "Founders' Experience" },
  { value: "25+", label: "Team Strength" },
  { value: "100%", label: "Accuracy" },
  { value: "24 Hr", label: "Max Turnaround" },
];

export const Stats = () => {
  return (
    <section id="results" data-testid="stats-section" className="bg-white py-20 md:py-28 border-t border-[#E5E5E5]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <p className="label-tech !text-[#3B37E5] mb-12">By the numbers</p>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-y-12">
          {stats.map((s, i) => (
            <motion.div
              key={s.label}
              data-testid={`stat-${i}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="px-2 md:px-6 md:border-l border-[#E5E5E5] md:first:border-l-0 md:first:pl-0"
            >
              <div className="font-display text-4xl md:text-5xl lg:text-[3.25rem] leading-none text-[#0A0A0A] mb-3">
                {s.value}
              </div>
              <div className="label-tech !text-[#9CA3AF]">{s.label}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
